module.exports = __webpack_public_path__ + "static/media/After Effects.409961c3.svg";